import * as THREE from 'three';

/**
 * Shared pooled geometry for high-frequency tool previews.
 *
 * Rubber-band previews follow the cursor at pointer-move rate. Recreating
 * their BufferGeometry on every render floods the GC and re-uploads GPU
 * buffers; a single static unit geometry driven by object scale updates one
 * matrix per move instead of rebuilding (and discarding) a BoxGeometry on
 * every preview tick.
 *
 * App-level statics: the object is never disposed by React (it lives for the
 * whole session), which is exactly what the pooling contract wants.
 */
export const UNIT_BOX_GEOMETRY = new THREE.BoxGeometry(1, 1, 1);
